// Enlaces de contacto (el usuario siempre presiona enviar/llamar en su app).
// Teléfonos de México: se usan los últimos 10 dígitos, igual que normalize_phone() en SQL.

export type Channel = "llamada" | "whatsapp" | "email" | "otro";

export const phone10 = (p?: string | null) => {
  const d = (p ?? "").replace(/\D/g, "");
  return d.length >= 10 ? d.slice(-10) : null;
};

export const telHref = (p?: string | null) => {
  const n = phone10(p);
  return n ? `tel:+52${n}` : null;
};

export const waHref = (p?: string | null, text?: string) => {
  const n = phone10(p);
  if (!n) return null;
  return (
    `https://wa.me/52${n}` + (text ? `?text=${encodeURIComponent(text)}` : "")
  );
};

export const mailHref = (
  email?: string | null,
  subject?: string,
  body?: string,
) => {
  if (!email) return null;
  const q = new URLSearchParams();
  if (subject) q.set("subject", subject);
  if (body) q.set("body", body);
  const qs = q.toString().replace(/\+/g, "%20");
  return `mailto:${email}` + (qs ? `?${qs}` : "");
};

/** Tipo de tarea (Atomic o cadencia) → canal de actividad. */
export const channelOf = (taskType?: string | null): Channel => {
  switch (taskType) {
    case "call":
    case "llamada":
      return "llamada";
    case "whatsapp":
      return "whatsapp";
    case "email":
      return "email";
    default:
      return "otro";
  }
};
